var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row align-items-center" }, [
    _c("div", { staticClass: "col-12", class: _vm.col_input }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.input.value,
            expression: "input.value"
          },
          {
            name: "tooltips-enabled",
            rawName: "v-tooltips-enabled",
            value: {
              active: _vm.tooltip,
              title: _vm.title
            },
            expression:
              "{\n                    active:tooltip,\n                    title:title\n                }"
          }
        ],
        staticClass:
          "code form-control border py-2 my-1 text-center text-uppercase",
        class: {
          "is-invalid": _vm.error
        },
        attrs: {
          maxlength: _vm.max_char,
          name: _vm.field,
          placeholder: _vm.placeholder ? _vm.placeholder : "",
          autocomplete: _vm.autocomplete,
          type: "text",
          tabindex: _vm.tabindex
        },
        domProps: { value: _vm.input.value },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.input, "value", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "col-12 row no-gutters align-items-center",
        class: _vm.col_btn_wrapper
      },
      [
        [
          this.input.value != ""
            ? _c(
                "BaseButtonRound",
                {
                  staticClass: "ml-0 my-0",
                  attrs: {
                    btn_type: _vm.validate_state.not_yet
                      ? "btn-warning"
                      : _vm.validate_state.valid ? "btn-alert" : "btn-danger",
                    type: "div",
                    small: false,
                    tooltip: false
                  },
                  nativeOn: {
                    click: function($event) {
                      _vm.codeExists()
                    }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("transition", { attrs: { name: "zoom" } }, [
                        _vm.validate_state.not_yet
                          ? _c("i", { staticClass: "material-icons" }, [
                              _vm._v("help")
                            ])
                          : _vm.validate_state.valid
                            ? _c("i", { staticClass: "material-icons" }, [
                                _vm._v("done")
                              ])
                            : _c("i", { staticClass: "material-icons" }, [
                                _vm._v("clear")
                              ])
                      ])
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        _vm._v(" "),
        _vm.show_refresh
          ? [
              _c(
                "BaseButtonRound",
                {
                  staticClass: "ml-0 my-0",
                  attrs: { type: "div", small: false, tooltip: false },
                  nativeOn: {
                    click: function($event) {
                      _vm.fetchCodeGenerated()
                    }
                  }
                },
                [
                  _c("template", { slot: "content" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("refresh")
                    ])
                  ])
                ],
                2
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-685e98d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685e98d6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseCodeInput.vue
// module id = 806
// module chunks = 0